import { useRef, type ChangeEvent } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { useTableDataFiles } from '../../queries/index.js';
import { EmptyState } from '../atoms/EmptyState.jsx';
import { PastImportsTable } from '../molecules/PastImportsTable.jsx';
import { RouterSearchBar } from '../molecules/RouterSearchBar.jsx';

export default function PastImportsTab() {
  const { t } = useTranslation('@myn/import-hub');

  const tableRef = useRef<{ onSearchChange: (search: string) => void } | null>(
    null,
  );

  const { data, isPending } = useTableDataFiles({
    throwOnError: true,
  });

  const hasNoImports = !isPending && !data.totalItems;

  if (hasNoImports) {
    return (
      <EmptyState
        icon="IllustrationEmptyState"
        text={t('There are no imported files yet')}
        description={t(
          'Click on the button in the top - right corner to start.',
        )}
      />
    );
  }

  return (
    <>
      <RouterSearchBar
        placeholder={t('Search for file name')}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          tableRef.current?.onSearchChange(e.target.value);
        }}
        className="mb-4"
      />
      <PastImportsTable ref={tableRef} />
    </>
  );
}
